import { usePlugins } from './pluginsEntitiesSlice';
import { hasActiveFlag } from './pluginsService';
import type { Plugin, PluginProductCode } from './types';

export function usePlugin(id: PluginProductCode): {
    plugin?: Plugin;
    isActive: boolean;
    isPending: boolean;
    error: unknown;
} {
    const { selectEntityById: selectPluginById, isPending, error } = usePlugins();

    const plugin = selectPluginById(id);
    const isActive = !!plugin && hasActiveFlag(plugin);

    return { plugin, isActive, isPending, error };
}
